import type { Dispatch, SetStateAction } from "react";

import {
  ComboBox,
  ComboBoxButton,
  ComboBoxGroup,
  ComboBoxInput,
  ComboBoxListBox,
  ComboBoxListItem,
  ComboBoxPopover,
} from "@/components/combobox";
import { Label } from "@/components/field";
import { Text } from "@/components/text";

import { phonePrefixes } from "../utils/phonePrefixes";

const prefixes = () => {
  const prefixItems = [];

  for (const [key, value] of Object.entries(phonePrefixes)) {
    prefixItems.push({ id: value, name: `${key} ${value}` });
  }

  return prefixItems;
};

export function SelectPrefix({
  setValue,
  value,
}: {
  setValue: Dispatch<SetStateAction<string>>;
  value: string;
}) {
  const data = prefixes();

  return (
    <ComboBox
      allowsEmptyCollection
      aria-label="Prefix"
      menuTrigger="input"
      onSelectionChange={(id) => setValue(String(id))}
      selectedKey={value}
    >
      <Label requiredHint>Prefix</Label>
      <ComboBoxGroup>
        <ComboBoxInput
          placeholder="Select prefix"
          style={{ MozBorderRadiusBottomright: "none" }}
        />
        <ComboBoxButton />
      </ComboBoxGroup>
      <ComboBoxPopover>
        <ComboBoxListBox
          aria-label="Prefix"
          className="max-h-[291px]"
          renderEmptyState={() => <Text className="p-2">No results found</Text>}
        >
          {data.map((type) => (
            <ComboBoxListItem id={type.id} key={type.name}>
              {type.name}
            </ComboBoxListItem>
          ))}
        </ComboBoxListBox>
      </ComboBoxPopover>
    </ComboBox>
  );
}
